import { useHandler } from "@redotech/react-util/hook";
import { createContext, useContext, useLayoutEffect, useState } from "react";
import { AuthContext } from "../app/auth";

export interface User {
  email: string;
  name: string;
  guestEmail?: string;
  guestName?: string;
  address?: string;
}

const NAME_TOKEN_KEY = "redo.user_name_token";
const EMAIL_TOKEN_KEY = "redo.email_token";
const GUEST_NAME_TOKEN_KEY = "redo.guest_name_token";
const GUEST_EMAIL_TOKEN_KEY = "redo.guest_email_token";
const ADDRESS_TOKEN_KEY = "redo.address_token";

export const UserContext = createContext<User | undefined>(undefined);

export const SetUserContext =
  createContext<(user: User | undefined) => void>(undefined);

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState<User | undefined>(undefined);
  const auth = useContext(AuthContext);

  useLayoutEffect(() => {
    if (auth) {
      setUser({
        name: localStorage.getItem(NAME_TOKEN_KEY),
        email: localStorage.getItem(EMAIL_TOKEN_KEY),
        guestEmail: localStorage.getItem(GUEST_EMAIL_TOKEN_KEY),
        guestName: localStorage.getItem(GUEST_NAME_TOKEN_KEY),
        address: localStorage.getItem(ADDRESS_TOKEN_KEY),
      });
    } else {
      setUser(undefined);
    }
  }, [auth]);

  const setUser_ = useHandler((user: User | undefined) => {
    setUser(user);
    if (user) {
      localStorage.setItem(NAME_TOKEN_KEY, user.name);
      localStorage.setItem(EMAIL_TOKEN_KEY, user.email);
      user.guestEmail &&
        localStorage.setItem(GUEST_EMAIL_TOKEN_KEY, user.guestEmail);
      user.guestName &&
        localStorage.setItem(GUEST_NAME_TOKEN_KEY, user.guestName);
      user.address && localStorage.setItem(ADDRESS_TOKEN_KEY, user.address);
    } else {
      localStorage.removeItem(NAME_TOKEN_KEY);
      localStorage.removeItem(EMAIL_TOKEN_KEY);
      localStorage.removeItem(GUEST_EMAIL_TOKEN_KEY);
      localStorage.removeItem(GUEST_NAME_TOKEN_KEY);
      localStorage.removeItem(ADDRESS_TOKEN_KEY);
    }
  });

  return (
    <UserContext.Provider value={user}>
      <SetUserContext.Provider value={setUser_}>
        {children}
      </SetUserContext.Provider>
    </UserContext.Provider>
  );
};
